import { colors, strings } from "assets/constants";
import { icons } from "assets/icons";

import {
  _goToAddAttribute,
  _goToAddCategory,
  _goToAddCustomer,
  _goToAddFactor,
  _goToAddNote,
  _goToAddProduct,
  _goToAddReminder,
  _goToAttributes,
  _goToCategories,
  _goToCustomers,
  _goToFactors,
  _goToNotes,
  _goToProducts,
  _goToReminders,
} from "routers/helper";
import { sn } from "utils";

const homePrimaryItems = (customer, factor) => [
  {
    imgIcon: { icon: icons._customers, size: 39 },
    title: strings.customers,
    color: "#d33e10",
    onPress: () => _goToCustomers({}),
    onAdd: _goToAddCustomer,
    total: customer?.total,
    counts: customer?.counts,
    countsDescription: "تعداد مشتری های واقعی به کل مشتری ها",
    section: <PermissionSectionsT>"customer",
  },
  {
    imgIcon: { icon: icons._factors, size: 40 },
    title: strings.factors,
    color: "#2bb57e",
    onPress: _goToFactors,
    onAdd: _goToAddFactor,
    total: factor?.total,
    counts: factor?.counts,
    countsDescription: "تعداد فاکتور های پذیرفته شده به کل فاکتور ها",
    section: <PermissionSectionsT>"factor",
  },
];

const productSectionItems = (attrsCounts, catsCounts, productsCounts) => [
  {
    imgIcon: { icon: icons._attributes, size: 20 },
    title: strings.attributes,
    color: "#CC5F00",
    c: colors.theme,
    onPress: _goToAttributes,
    onAdd: _goToAddAttribute,
    counts: attrsCounts,
    section: <PermissionSectionsT>"attribute",
  },
  {
    imgIcon: { icon: icons._categories, size: 20 },
    title: strings.categories,
    color: "#388E3C",
    c: colors.theme,
    onPress: _goToCategories,
    onAdd: _goToAddCategory,
    counts: catsCounts,
    section: <PermissionSectionsT>"category",
  },
  {
    imgIcon: { icon: icons._products, size: 20 },
    title: strings.products,
    color: "#C2185B",
    c: colors.theme,
    onPress: _goToProducts,
    onAdd: _goToAddProduct,
    counts: productsCounts,
    section: <PermissionSectionsT>"product",
  },
];

const otherItems = (remindersCounts, notesCounts) => [
  {
    imgIcon: { icon: icons._reminders, size: 20 },
    title: strings.reminders,
    color: "#c21162",
    c: colors.theme,
    onPress: _goToReminders,
    onAdd: _goToAddReminder,
    counts: remindersCounts,
    section: <PermissionSectionsT>"reminder",
  },
  {
    imgIcon: { icon: icons._notes, size: 20 },
    title: strings.notes,
    color: "#c75600",
    c: colors.theme,
    onPress: _goToNotes,
    onAdd: _goToAddNote,
    counts: notesCounts,
    section: <PermissionSectionsT>"note",
  },
];

export { productSectionItems, homePrimaryItems, otherItems };
